import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { ConfirmationPopupData, ConfirmationPopupResult } from './confirmation-popup';

@Component({
  selector: 'app-confirmation-popup',
  standalone: true,
  templateUrl: './confirmation-popup.component.html',
  imports: [MatDialogTitle, MatDialogActions, MatButton, MatDialogClose, MatDialogContent, MatIcon],
  styleUrl: './confirmation-popup.component.scss'
})
export class ConfirmationPopupComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationPopupData,
    private matDialogRef: MatDialogRef<ConfirmationPopupComponent, ConfirmationPopupResult>
  ) {}

  onConfirm() {
    this.matDialogRef.close('Confirmed');
  }
}
